import { useNullableDealerAccountInfo } from "./useNullableDealerAccountInfo";

export const useDealerAddress = (): string => {
  const dealer = useNullableDealerAccountInfo();
  const address = [
    dealer?.dealerAddress,
    dealer?.dealerCity,
    dealer?.dealerState,
  ]
    .filter(Boolean)
    .join(", ");

  if (address && dealer?.dealerPostalCode) {
    return `${address} (${dealer.dealerPostalCode})`;
  }

  return address;
};
